var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"premium-features"},[_c('div',{staticClass:"premium-features-heading"},[_vm._v("Premium Membership Includes:")]),_vm._l((_vm.features),function(feature,i){return _c('div',{key:i,staticClass:"premium-feature"},[_c('i',{staticClass:"premium-feature-icon"}),_c('span',[_vm._v(" "+_vm._s(feature)+" ")])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }